// extracted by css-extract-rspack-plugin
export default {"HeaderText":"Dgj3y","HeaderTextCentered":"MOBPB","HeaderTextContent":"cVuM2","HeaderTextContainer":"Gjm4P","clickable":"sNELH","HeaderContainer":"iNHR8"};